export default function (date) {
    return !Number.isNaN(Date.parse(date));
}
